// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2IJK6","tabsBox":"styles_tabsBox__AtwFj","createButton":"styles_createButton__D1Vjw"};